import { useNavigate } from "react-router-dom";
import CircleTextPng from "../assets/images/home/circle-text-png.png";
import FooterImgWoman from "../assets/images/home/footer-img-woman.png";
import FacebookSvg from "../assets/images/svg/facebook.svg";
import FooterArrow from "../assets/images/svg/footer-arrow.svg";
import LinkedinSvg from "../assets/images/svg/linkedin.svg";
import LogoSvg from "../assets/images/svg/logo.png";
import MediumSvg from "../assets/images/svg/medium.svg";
import WhatsappFooter from "../assets/images/svg/whatsapp-footer.svg";


const Footer = () => {
    
    const navigate = useNavigate();
        const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({ behavior: "smooth" });
        }
    };
    return (
        <>
            {/* <!-- ====================================== Footer ===================================== --> */}
            <footer className="footer position-relative">
                <div className="footer-sub">
                    <div className="container">
                        <div className="row">
                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 footer-col1">
                                <h2
                                    className="section-heading-text lets-work-together"
                                    data-aos="fade-up"
                                >
                                    Vamos
                                    <span> trabalhar juntos?</span>
                                </h2>

                                <div className="footer-menu">
                                    <img onClick={() => navigate("/")} src={LogoSvg} alt="logo" />
                                    <ul className="top-navbar-title">
                                        <li onClick={() => scrollToSection("sobre")}>Início</li>
                                        <li onClick={() => scrollToSection("servicos")}>Serviços</li>
                                        <li onClick={() => window.open('https://wa.me/552731910677', '_blank')}>Contato</li>
                                    </ul>
                                </div>

                                <p className="neque">
                                    O trabalho do Philippe é ajudar você a enxergar com mais clareza
                                    o momento em que está, organizar suas decisões e construir,
                                    com método, movimentos possíveis para a sua vida e para os seus
                                    negócios. Sempre com conversa direta, respeito à sua história
                                    e foco em resultados reais, não em fórmulas prontas.
                                </p>
                            </div>

                            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-12 position-relative footer-col2">
                                <div className="view-work-circle">
                                    <div onClick={() => navigate("/")} className="a1">
                                        <img className="circle-text-png" src={CircleTextPng} alt="circle-text-png" />
                                        <img className="footer-arrow" src={FooterArrow} alt="footer-arrow" />
                                    </div>
                                </div>
                                <img className="footer-img-woman" src={FooterImgWoman} alt="footer-img-woman" />
                            </div>
                        </div>
                    </div>

                    <div className="copyrights-footer-main">
                        <div className="container copyrights-container">
                            <h3 className="copy-right">
                                © 2024 Philippe Sassi – Todos os direitos reservados
                            </h3>
                            <div className="home-media-icon-main-head">
                                <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
                                    <div className="home-media-icon-main social-button">
                                        <img src={FacebookSvg} alt="facebook" />
                                    </div>
                                </a>
                                <a href="https://wa.me/552731910677" target="_blank" rel="noopener noreferrer">
    <div className="home-media-icon-main social-button">
        <img src={WhatsappFooter} alt="whatsapp" />
    </div>
</a>

                                <a href="https://www.linkedin.com" target="_blank" rel="noopener noreferrer">
                                    <div className="home-media-icon-main social-button">
                                        <img src={LinkedinSvg} alt="linkedin" />
                                    </div>
                                </a>
                                <a href="https://medium.com" target="_blank" rel="noopener noreferrer">
                                    <div className="home-media-icon-main social-button">
                                        <img src={MediumSvg} alt="medium" />
                                    </div>
                                </a>
                            </div>
                        </div>
                    </div>

                </div>
            </footer>
        </>
    )
}

export default Footer
